/* Restaura el negocio (Deal)

Autor: Benjamín León
Fecha: 2024-12-31
*/
import { useState } from 'react'

import { customPost } from '../utils/customFetch.ts'

import { makeUrlDealRestore } from './connectionData.tsx'
const apiUrl = makeUrlDealRestore()

const useDealRestore = () => {
  const [dealRestoreError, setDealRestoreError] = useState<Error | null>(null)
  const [loading, setLoading] = useState<boolean>(false)

  const dealRestore = async (id: string) => {
    setLoading(true)

    try {
      await customPost(apiUrl, { _id: id })

      setDealRestoreError(null)
    } catch (err) {
      // Assert the error as an instance of Error
      if (err instanceof Error) {
        setDealRestoreError(err)
      } else {
        setDealRestoreError(new Error('An unknown error occurred'))
      }
    } finally {
      setLoading(false)
    }
  }

  // Exponemos estas variables al exterior
  return { dealRestoreError, loading, dealRestore }
}
export default useDealRestore
